<template>
  <h2 v-if="$slots.title">
    <slot name="title" />
  </h2>
  <p v-if="$slots.copy">
    <slot name="copy" />
  </p>
</template>

<style lang="scss" scoped>
h2 {
  color: var(--gray-900);
  font-weight: 700;
  font-size: var(--typ-h2);
  text-align: center;
  margin: 0 0 14px;
  @media screen and (max-width: 768px) {
    font-size: var(--typ-h3);
    margin: 0 0 12px;
  }
  @media screen and (max-width: 540px) {
    font-size: var(--typ-h4);
    margin: 0 0 8px;
  }
}
p {
  font-size: var(--type-body3);
  font-weight: 400;
  text-align: center;
  color: var(--gray-700);
  margin: 0 auto;
  @media screen and (max-width: 768px) {
    font-size: var(--typ-body5);
    max-width: 290px;
  }
}
</style>